module.exports = __webpack_public_path__ + "img/关于我们banner备份.60cc9af8.jpg";